import styled from 'styled-components';

export const GoalsHeadersContainer = styled.div<{ fullWidth: boolean }>`
  display: grid;
  width: 100%;
  height: ${(props) =>
    props.fullWidth
      ? '20px'
      : '44px'}; // Use props for accessing fullWidth in v6
  margin-bottom: ${(props) => (props.fullWidth ? '30px' : '0')};
  grid-template-columns: ${(props) =>
    props.fullWidth ? '1fr' : '1fr 1fr 1fr 1fr'};
  padding-left: ${(props) => (props.fullWidth ? '0' : '20px')};
  padding-right: ${(props) => (props.fullWidth ? '0' : '20px')};
  gap: 32px;
  background: ${(props) =>
    props.theme
      .goalsTableContainerBackground}; // Use props for theme access in v6

  @media (max-width: 768px) {
    grid-template-columns: ${(props) =>
      props.fullWidth ? '1fr' : '274px 274px 274px 274px'};
  }
`;

export const GoalsHeaderTitle = styled.h1`
  font-size: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 12px;
  @media (max-width: 768px) {
    width: 100%;
    padding: 10px;
  }
`;
